import React, { createContext, useContext } from 'react';

const I18nContext = createContext({
  t: (_key, fallback) => fallback || ''
});

export function I18nProvider({ children }) {
  const t = (key, fallback) => fallback || key;
  return <I18nContext.Provider value={{ t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
